import { render, staticRenderFns } from "./zDev.vue?vue&type=template&id=050d5260&scoped=true&"
import script from "./zDev.vue?vue&type=script&setup=true&lang=js&"
export * from "./zDev.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050d5260",
  null
  
)

export default component.exports